const language = {

    english: {
        buttons: {
            start: 'Start',
            home: 'Home',
            newgame: 'New Game',
            roll: 'Roll Dice',
            hold: 'Hold'
        },
        labels: {
            howtoplay: 'How to play the game?',
            winner: 'Winner!',
            current: 'Current',
            p1rolled1: "Sorry! You rolled 1. Player 2's turn",
            p2rolled1: "Sorry! You rolled 1. Player 1's turn",
            commence: "Commence",
            raceto: "Race To",
            back: "Go Back",
            p1namelabel: "Player 1's name",
            p2namelabel: "Player 2's name",
            targetscorelabel: "Target Score",
            p1formlabel: "Has a perk to roll the dice first",
            targetscoreformlabel: "Original game had a goal of 100"
        },
        instructions: {
            ptag1: "A player rolls a die and scores as many points as the total shown on the die providing the die doesn’t roll a 1. The player may continue rolling and accumulating points(but risk rolling a 1) to his current/roundscore or end his turn.Ending his turn by pressing hold and it will be added to his global/ total score",
            ptag2: "If the player rolls a 1 his turn is over, he loses all points he accumulated that turn, and he passes the die to the next player.",
            ptag3: "The first player to accumulate set target points or more points wins the game."
        }
    },


    filipino: {
        buttons: {
            start: 'Umpisahan',
            home: 'Bahay',
            newgame: 'Bagong Laro',
            roll: 'Gumulong',
            hold: 'Hawakan'
        },
        labels: {
            howtoplay: 'Paano laruin ang laro?',
            winner: 'Nagwagi!',
            current: 'Kasalukuyan',
            p1rolled1: "Pasensya na! Nakakuha ka ng 1. Si Manlalaro 2 na maglalaro",
            p2rolled1: "Pasensya na! Nakakuha ka ng 1. Si Manlalaro 1 na maglalaro",
            commence: "Magsimula",
            raceto: "Takda",
            back: "Bumalik",
            p1namelabel: "Pangalan ng Player 1",
            p2namelabel: "Pangalan ng Player 2",
            targetscorelabel: "Takdang Puntos",
            p1formlabel: "Unang magroroll ng dice",
            targetscoreformlabel: "Ang orihinal na laro ay takdang puntos na 100"
        },
        instructions: {
            ptag1: "Ang isang manlalaro ay gumugulong ng isang dice at nakakakuha ng maraming mga puntos tulad ng kabuuang ipinakita sa dice na nagbibigay ng dice ay hindi gumulong ng isang 1. Maaaring magpatuloy ang manlalaro sa pag-ikot at pag-iipon ng mga puntos (ngunit ipagsapalaran ang pag-ikot ng 1) sa kanyang kasalukuyang / pag-ikot o wakasan ang pagtatapos. Ang pagtatapos ng kanyang pagliko sa pamamagitan ng pagpindot sa pagpindot at idaragdag ito sa kanyang pandaigdigan / kabuuang iskor",
            ptag2: "Kung ang manlalaro ay gumulong ng 1 sa kanyang turn ay tapos na, mawala sa kanya ang lahat ng mga puntos na naipon niya sa pagliko na iyon, at ipinapasa niya ang mamatay sa susunod na manlalaro.",
            ptag3: "Ang unang manlalaro na naipon ang mga itinakdang puntong target o higit pang mga puntos ay nanalo sa laro."
        }
    },


    german: {
        buttons: {
            start: 'Start',
            home: 'Zuhause',
            newgame: 'Neues Spiel',
            roll: 'Würfeln',
            hold: 'Halt'
        },
        labels: {
            howtoplay: 'Wie spiele ich das Spiel?',
            winner: 'Gewinner!',
            current: 'Aktuell',
            p1rolled1: "Bitte! Du hast 1 gewürfelt. Spieler 2's wenden",
            p2rolled1: "Bitte! Du hast 1 gewürfelt. Spieler 1's wenden",
            commence: "Beginnen",
            raceto: "Rennen zu",
            back: "geh zurück",
            p1namelabel: "Name von Spieler 1",
            p2namelabel: "Name von Spieler 2",
            targetscorelabel: "Zielpunktzahl",
            p1formlabel: "Hat einen Vorteil, zuerst zu würfeln",
            targetscoreformlabel: "Das ursprüngliche Spiel hatte ein Ziel von 100"
        },
        instructions: {
            ptag1: "Ein Spieler würfelt und erhält so viele Punkte wie die auf dem Würfel angegebene Summe, sofern der Würfel keine 1 würfelt. Der Spieler kann weiter würfeln und Punkte sammeln (riskiert jedoch, eine 1 zu würfeln), um seinen aktuellen / runden Punktestand zu erreichen oder seinen zu beenden Wenn Sie seinen Zug durch Drücken von Halten beenden, wird er zu seiner globalen / Gesamtpunktzahl hinzugefügt",
            ptag2: "Wenn der Spieler eine 1 würfelt, verliert er alle Punkte, die er in diesem Zug gesammelt hat, und gibt den Würfel an den nächsten Spieler weiter.",
            ptag3: "Der erste Spieler, der festgelegte Zielpunkte oder mehr Punkte sammelt, gewinnt das Spiel."
        }
    },


    portuguese: {
        buttons: {
            start: 'Começar',
            home: 'Casa',
            newgame: 'Novo jogo',
            roll: 'Jogue dados',
            hold: 'Aguarde'
        },
        labels: {
            howtoplay: 'Como jogar o jogo?',
            winner: 'Vencedor!',
            current: 'Atual',
            p1rolled1: "Desculpe! Você rolou 1. Turno do Jogador 2",
            p2rolled1: "Desculpe! Você rolou 1. Turno do Jogador 1",
            commence: "Começar",
            raceto: "Corrida para",
            back: "Volte",
            p1namelabel: "Nome do jogador 1",
            p2namelabel: "Nome do jogador 2",
            targetscorelabel: "Pontuação Alvo",
            p1formlabel: "Tem a vantagem de lançar os dados primeiro",
            targetscoreformlabel: "O jogo original tinha uma meta de 100"
        },
        instructions: {
            ptag1: "Um jogador rola um dado e marca tantos pontos quanto o total mostrado no dado, desde que o dado não role 1. O jogador pode continuar rolando e acumulando pontos (mas arrisca rolar um 1) para sua pontuação atual / rodada ou terminar seu Vire. Terminar sua vez pressionando hold e será adicionado à sua pontuação global / total",
            ptag2: "Se o jogador rolar 1, seu turno acaba, ele perde todos os pontos que acumulou naquele turno e passa o dado para o próximo jogador.",
            ptag3: "O primeiro jogador a acumular pontos-alvo definidos ou mais pontos ganha o jogo."
        }
    },


    spanish: {
        buttons: {
            start: 'Comienzo',
            home: 'Hogar',
            newgame: 'Nuevo juego',
            roll: 'Tirar el dado',
            hold: 'Sostener'
        },
        labels: {
            howtoplay: 'Cómo jugar el juego?',
            winner: 'Ganador!',
            current: 'Actual',
            p1rolled1: "¡Lo siento! Sacaste 1. Turno del jugador 2",
            p2rolled1: "¡Lo siento! Sacaste 1. Turno del jugador 1",
            commence: "Comenzar",
            raceto: "Carrera a",
            back: "Regresa",
            p1namelabel: "Nombre del jugador 1",
            p2namelabel: "Nombre del jugador 2",
            targetscorelabel: "Puntuación objetivo",
            p1formlabel: "Tiene la ventaja de lanzar los dados primero",
            targetscoreformlabel: "El juego original tenía un objetivo de 100"
        },
        instructions: {
            ptag1: "Un jugador lanza un dado y obtiene tantos puntos como el total que se muestra en el dado, siempre que el dado no arroje un 1. El jugador puede continuar tirando y acumulando puntos (pero se arriesga a sacar un 1) a su puntaje actual / ronda o terminar su Finalizar su turno presionando mantener y se agregará a su puntuación global / total",
            ptag2: "Si el jugador saca un 1, su turno ha terminado, pierde todos los puntos que acumuló ese turno y pasa el dado al siguiente jugador.",
            ptag3: "El primer jugador en acumular puntos de destino establecidos o más puntos gana el juego."
        }
    },


    italian: {
        buttons: {
            start: 'Inizio',
            home: 'Casa',
            newgame: 'Nuovo gioco',
            roll: 'Lancia i dadi',
            hold: 'Aspetta'
        },
        labels: {
            howtoplay: 'Come si gioca?',
            winner: 'Vincitore!',
            current: 'Attuale',
            p1rolled1: "Spiacente! Hai ottenuto 1. Turno del giocatore 2",
            p2rolled1: "Spiacente! Hai ottenuto 1. Turno del giocatore 1",
            commence: "Inizio",
            raceto: "correre a",
            back: "torna indietro",
            p1namelabel: "Nome del giocatore 1",
            p2namelabel: "Nome del giocatore 2",
            targetscorelabel: "Punteggio obiettivo",
            p1formlabel: "Ha il vantaggio di tirare prima i dadi",
            targetscoreformlabel: "Il gioco originale aveva un obiettivo di 100"
        },
        instructions: {
            ptag1: "Un giocatore tira un dado e ottiene tanti punti quanti sono i totali mostrati sul dado, a condizione che il dado non tiri un 1. Il giocatore può continuare a tirare e accumulare punti (ma rischia di tirare un 1) fino al suo punteggio corrente / round o terminare il suo Terminare il proprio turno tenendo premuto e verrà aggiunto al suo punteggio globale / totale",
            ptag2: "Se il giocatore tira un 1, il suo turno è finito, perde tutti i punti accumulati in quel turno e passa il dado al giocatore successivo.",
            ptag3: "Il primo giocatore ad accumulare punti target prefissati o più punti vince la partita."
        }
    },


    japanese: {
        buttons: {
            start: '開始',
            home: 'ホーム',
            newgame: '新しいゲーム',
            roll: 'さいころを振る',
            hold: 'ホールド'
        },
        labels: {
            howtoplay: 'ゲームの遊び方?',
            winner: '勝者!',
            current: '電流',
            p1rolled1: "ごめんなさい！ あなたは1を出しました。プレイヤー2のターン",
            p2rolled1: "ごめんなさい！ あなたは1を出しました。プレイヤー1のターン",
            commence: "開始",
            raceto: "に競争する",
            back: "戻る",
            p1namelabel: "プレイヤー1の名前",
            p2namelabel: "プレイヤー2の名前",
            targetscorelabel: "目標スコア",
            p1formlabel: "最初にサイコロを振る特典があります",
            targetscoreformlabel: "オリジナルゲームの目標は100"
        },
        instructions: {
            ptag1: "プレイヤーはサイコロを振って、サイコロが1を出さない限り、サイコロに表示されている合計と同じ数のポイントを獲得します。 ターン：ホールドを押してターンを終了すると、グローバル/合計スコアに追加されます。",
            ptag2: "プレイヤーが1ターン終わった場合、そのターンに蓄積したすべてのポイントを失い、ダイスを次のプレイヤーに渡します。",
            ptag3: "設定した目標ポイント以上を貯めた最初のプレイヤーがゲームに勝ちます。"
        }
    },


    korean: {
        buttons: {
            start: '스타트',
            home: '집',
            newgame: '새로운 게임',
            roll: '롤 주사위',
            hold: '보류'
        },
        labels: {
            howtoplay: '게임은 어떻게하나요?',
            winner: '우승자!',
            current: '흐름',
            p1rolled1: "죄송합니다! 1을 굴 렸습니다. 플레이어 2의 차례",
            p2rolled1: "죄송합니다! 1을 굴 렸습니다. 플레이어 1의 차례",
            commence: "시작",
            raceto: "경주하다",
            back: "돌아가다",
            p1namelabel: "선수 1의 이름",
            p2namelabel: "선수 2의 이름",
            targetscorelabel: "목표 점수",
            p1formlabel: "주사위를 먼저 굴릴 수있는 특전이 있습니다.",
            targetscoreformlabel: "원래 게임의 목표는 100입니다."
        },
        instructions: {
            ptag1: "플레이어는 주사위를 굴리고 주사위에 표시된 총점만큼 점수를 얻습니다. 단, 주사위가 1이 나오지 않는 경우 플레이어는 계속해서 주사위를 굴리고 점수를 누적 할 수 있습니다 (그러나 1을 굴릴 위험이 있음). 홀드를 눌러 그의 턴을 끝내면 그의 글로벌 / 총점에 추가됩니다.",
            ptag2: "플레이어가 1을 굴리면 자신의 턴이 끝났고, 그 턴에 누적 한 모든 점수를 잃고 주사위를 다음 플레이어에게 넘깁니다.",
            ptag3: "설정된 목표 포인트 이상을 가장 먼저 모은 플레이어가 게임에서 승리합니다."
        }
    },


    french: {
        buttons: {
            start: 'Début',
            home: 'Accueil',
            newgame: 'Nouveau jeu',
            roll: 'Roulez les dés',
            hold: 'Tenir'
        },
        labels: {
            howtoplay: 'Comment jouer au jeu?',
            winner: 'Gagnant!',
            current: 'Actuel',
            p1rolled1: "Pardon! Vous avez obtenu 1. Tour du joueur 2",
            p2rolled1: "Pardon! Vous avez obtenu 1. Tour du joueur 1",
            commence: "Commencer",
            raceto: "course à",
            back: "retourner",
            p1namelabel: "Nom du joueur 1",
            p2namelabel: "Nom du joueur 2",
            targetscorelabel: "Score cible",
            p1formlabel: "A l'avantage de lancer les dés en premier",
            targetscoreformlabel: "Le jeu original avait un objectif de 100"
        },
        instructions: {
            ptag1: "Un joueur lance un dé et marque autant de points que le total indiqué sur le dé à condition que le dé ne lance pas un 1. Le joueur peut continuer à lancer et accumuler des points (mais risquer de lancer un 1) à son score actuel / rond ou terminer son Fin de son tour en appuyant sur hold et il sera ajouté à son score global / total",
            ptag2: "Si le joueur obtient un 1, son tour est terminé, il perd tous les points qu'il a accumulés pendant ce tour et passe le dé au joueur suivant.",
            ptag3: "Le premier joueur à accumuler des points cibles définis ou plus de points remporte la partie."
        }
    },


    russian: {
        buttons: {
            start: 'Начало',
            home: 'Дом',
            newgame: 'Новая игра',
            roll: 'Игральная кость',
            hold: 'Держать'
        },
        labels: {
            howtoplay: 'Как играть в игру?',
            winner: 'Победитель!',
            current: 'ток',
            p1rolled1: "Сожалею! Вы выбросили 1. Ход игрока 2",
            p2rolled1: "Сожалею! Вы выбросили 1. Ход игрока 1",
            commence: "Начать",
            raceto: "гонка к",
            back: "Вернитесь",
            p1namelabel: "Имя игрока 1",
            p2namelabel: "Имя игрока 2",
            targetscorelabel: "Целевой показатель",
            p1formlabel: "Имеет способность сначала бросать кости.",
            targetscoreformlabel: "В оригинальной игре была цель - 100"
        },
        instructions: {
            ptag1: "Игрок бросает кубик и набирает столько очков, сколько указано на кубике, при условии, что кубик не выбрасывает 1. Игрок может продолжать бросать и накапливать очки (но рискует выбросить 1) до своего текущего / раундового счета или закончить свой В конце своего хода нажмите и удерживайте, и он будет добавлен к его глобальному / общему счету.",
            ptag2: "Если игрок выбрасывает 1, его ход заканчивается, он теряет все очки, накопленные за этот ход, и передает кубик следующему игроку.",
            ptag3: "Первый игрок, который наберет заданные целевые очки или больше очков, побеждает в игре."
        }
    }
}

// flags from https://emojipedia.org/flags/